export type CardScanError = {
  message: string;
  type: string;
  code: number;
  isCardScanError: boolean;
};

export type XMLError = {
  Message: { _text: string };
  Code: { _text: string };
};

export const XMLErrortoCardScanError = (
  xmlErrorObj: XMLError,
  code: number
): CardScanError => ({
  message: xmlErrorObj.Message._text,
  type: xmlErrorObj.Code._text,
  code: code,
  isCardScanError: true,
});

export const generateError = (
  message: string,
  type = "ApiError",
  code = 696
): CardScanError => ({
  message: message,
  type: type,
  code: code,
  isCardScanError: true,
});
